// extracted by mini-css-extract-plugin
export default {"token":"token_token__gNzli","tokenContent":"token_tokenContent__j1FJJ","tokenIcon":"token_tokenIcon__jxENP","tokenPoints":"token_tokenPoints__AVG2O"};